
export default {
  mileageCategories: state => state.mileageCategories,
  mileageCategoriesFilters: state => state.mileageCategoriesFilters,
  mileageCategoriesCurrentPage: state => state.mileageCategoriesCurrentPage,
  mileageCategoriesLastPage: state => state.mileageCategoriesLastPage,
  dietCategories: state => state.dietCategories,
  dietCategoriesFilters: state => state.dietCategoriesFilters,
  dietCategoriesCurrentPage: state => state.dietCategoriesCurrentPage,
  dietCategoriesLastPage: state => state.dietCategoriesLastPage
}
